import styled from 'styled-components';
import { Header4 } from '../Typography/Header4';

export const CardHeader = styled.div`
  color: var(--primary-color-darker);
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${Header4} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  i {
    transition: margin-right 0.5s;
  }
`;

export const CardContent = styled.div`
  display: flex;
  padding: 0;
`;

export const CardDetails = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  font-size: 1rem;
  padding: 20px;
  color: var(--primary-color-darkest);

  :first-child {
    padding-left: 0;
  }

  :not(:last-child):after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    width: 1px;
    height: 40px;
    background: rgba(var(--primary-color-rgb), 0.5);
  }
`;
